import { DatasourceStatus, IntegrationStatus } from './types';

export const getDatasourceStatus = (
  integrationStatuses: IntegrationStatus[],
): DatasourceStatus => {
  if (integrationStatuses.length === 0) {
    return DatasourceStatus.inactive;
  }

  let result = DatasourceStatus.inactive;

  for (let status of integrationStatuses) {
    if (status === IntegrationStatus.failed) {
      result = DatasourceStatus.error;

      break;
    }

    if (status === IntegrationStatus.connected) {
      result = DatasourceStatus.active;
    }
  }

  return result;
};
